import React from 'react';

export default (props) => (
    <div className="left-content left-content-width" style={{justifyContent: "start"}}>
        <div className="left-content__fixed">
            {props.children}
        </div>
    </div>
)


// WEBPACK FOOTER //
// ./src/components/Commons/LeftNavContent.js